define('OutSystems/ClientRuntime/modules/Native/IOutSystemsNativeHost',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isIOutSystemsNativeHost = void 0;
    function isIOutSystemsNativeHost(obj) {
        return !!(obj === null || obj === void 0 ? void 0 : obj.OutSystemsNative);
    }
    exports.isIOutSystemsNativeHost = isIOutSystemsNativeHost;
});
//# sourceMappingURL=IOutSystemsNativeHost.js.map;
